import * as React from 'react';
import { Link } from '@cian/ui-kit';

import { IDeveloperCell } from '../../../../../../types/newbuildingsCompare';
import { trackCheckDeveloperInfoEvent } from '../tracking';
import { getDeveloperLink } from './getDeveloperLink';
import * as style from './style.css';

export interface IDeveloperLinkCellProps {
  cell: IDeveloperCell;
}

export const DeveloperLinkCell = ({ cell }: IDeveloperLinkCellProps): React.JSX.Element => {
  const developerLink = getDeveloperLink(cell.data?.id);

  return (
    <div className={style['developer-link-container']} data-testid="check-developers-page-links">
      <span className={style['developer-link']}>
        <Link
          font-text="text-main-default"
          fontWeight="bold"
          href={developerLink}
          onClick={trackCheckDeveloperInfoEvent}
          target="_blank"
        >
          О застройщике
        </Link>
      </span>
    </div>
  );
};
